import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { getLoyaltyCheckoutLoungePassFilters } from 'checkout/selectors/experienceSelectors'
import { getExperienceListKey } from 'lib/experiences/experienceUtils'

const getCanRedeemLoungePassLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => getLoyaltyCheckoutLoungePassFilters(state),
  (state: App.State) => state.experience.experienceLists,
  (
    userBenefits,
    isInternationalTrip,
    isCurrentRegionUserLoyaltyRegion,
    loyaltyCheckoutLoungePassFilters,
    experienceLists,
  ): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion) return false

    const loungePassBenefit = userBenefits?.find(benefit => benefit.code === 'lounge_pass')

    if (
      !loungePassBenefit || (!loungePassBenefit.unlimited && !loungePassBenefit.remaining)
    ) return false

    const fetchingOffers = loyaltyCheckoutLoungePassFilters.some(filter => experienceLists[getExperienceListKey(filter)]?.fetching)
    const offersCount = loyaltyCheckoutLoungePassFilters.reduce((acc, filter) => acc + (experienceLists[getExperienceListKey(filter)]?.total ?? 0), 0)
    const hasLoungePassesAvailable = !fetchingOffers && offersCount > 0

    // Can redeem lounge passes when they have some remaining, it's an international order
    // and our config says we have lounge pass experiences available
    return hasLoungePassesAvailable && isInternationalTrip
  },
)

export default getCanRedeemLoungePassLoyaltyBenefit
